import { Database, Activity, Clock, Server } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const StatsCards = ({ estadistica, pidData }) => {
  const totalConnections = estadistica?.data?.reduce(
    (acc, db) => acc + (db.total || 0),
    0
  ) || 0;

  const activeConnections = estadistica?.data?.reduce(
    (acc, db) => acc + (db.active || 0),
    0
  ) || 0;

  const idleConnections = estadistica?.data?.reduce(
    (acc, db) => acc + (db.idle || 0),
    0
  ) || 0;

  const avgMemory = estadistica?.data?.length
    ? (
        estadistica.data.reduce((acc, db) => acc + (db.memory || 0), 0) /
        estadistica.data.length
      ).toFixed(2)
    : 0;

  const stats = [
    {
      title: "Total Connections",
      value: totalConnections,
      icon: Database,
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      title: "Active Connections",
      value: activeConnections,
      icon: Activity,
      color: "text-success",
      bgColor: "bg-success/10"
    },
    {
      title: "Idle Connections",
      value: idleConnections,
      icon: Clock,
      color: "text-status-idle",
      bgColor: "bg-muted"
    },
    {
      title: "Avg Memory (MB)",
      value: avgMemory,
      icon: Server,
      color: "text-accent",
      bgColor: "bg-accent/10"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <Card key={index} className="border-border hover:border-primary/50 transition-colors">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-muted-foreground">{stat.title}</p>
                <p className="text-3xl font-bold text-foreground mt-2">{stat.value}</p>
              </div>
              <div className={`p-3 rounded-lg ${stat.bgColor}`}>
                <stat.icon className={`h-6 w-6 ${stat.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StatsCards;
